import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {WorkspaceId} from "@/sdk.ts";
import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

export namespace BootcampListRoute {
  export function record(): RouteRecordRaw {
    return {
      name: 'bootcamp_list',
      path: '/workspace/:workspaceId/bootcamps',
      component: customAsyncComponent(async () => import('./views/BootcampListView.vue')),
      meta: {
        hasNav: true,
        requiresAuth: true,
        //requiresAdmin: true,
        localeCategories: [
          LOCALE_CATEGORIES.BOOTCAMP
        ],
        pageHeader: {
          showHome: false,
          showTitle: false,
          title: '',
          breadcrumb: []
        }
      },
    }
  }

  export function location(workspaceId: number): RouteLocationRaw {
    return {name: 'bootcamp_list', params: {workspaceId}};
  }

  export function getParams(router: Router): { workspaceId: WorkspaceId; } {
    return {
      workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
    }
  }
}

export function getBootcampListRouteLocation(workspaceId: number): RouteLocationRaw {
  return {name: 'bootcamp_list', params: {workspaceId}};
}

export function getBootcampListRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}